import script from "./products_list_total.vue?vue&type=script&setup=true&lang=js"
export * from "./products_list_total.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__